export const taskStatusFilterTypes = {
  ALL_COMPLETED_TASKS: "all",
  COMPLETED_WITH_CHANGES: "with_changes",
  COMPLETED_WITHOUT_CHANGES: "without_changes",
};
